import React, { useEffect, useState } from "react";
import { RenderMarkdownWithLatex } from "../../utils/utils";
import ReportIssueModal from "./ReportIssueModal";
import CorrectionModal from "./CorrectionModal"; 
import AiChatPopup from "../molecules/AiChatPopup";
import {
  startChatAndGenerateSolution,
  continueChat,
} from "../../services/geminiService";
import SubfieldManagerModal from "../../components/admin/SubfieldManagerModal"; // UPEWNIJ SIĘ, ŻE ŚCIEŻKA JEST POPRAWNA
import ProblemManagerModal from '../../components/admin/ProblemManagerModal'; // Popraw ścieżkę
import SubfieldSummary from '../../components/admin/SubfieldSummary'; // Dostosuj ścieżkę, jeśli trzeba
import SolutionStepper from '../molecules/SolutionStepper';
import HintAndFormulas from '../molecules/HintAndFormulas';
// URL do API pobierany z .env
const apiUrl = process.env.REACT_APP_API_SOURCE;
const token = localStorage.getItem("token");

const MaturaDataArraySection = ({ title, items }) => {
  if (!items || !Array.isArray(items) || items.length === 0 || items.every(item => !item && typeof item !== 'number')) {
    return null;
  }
  return (
    <div className="mt-3 pt-3 border-t border-gray-200">
      <h5 className="text-[0.92rem] font-semibold text-gray-500 mb-1.5">{title}:</h5>
      <ul className="list-none pl-0 text-[0.9rem] text-gray-700 space-y-1">
        {items.map((item, index) => (
          (item || typeof item === 'number') && (
            <li key={index}>
              <RenderMarkdownWithLatex text={String(item)} />
            </li>
          )
        ))}
      </ul>
    </div>
  );
};

const MaturaDataSingleValueSection = ({ title, value }) => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return null;
  }
  return (
    <div className="mt-3 pt-3 border-t border-gray-200">
      <h5 className="text-[0.92rem] font-semibold text-gray-500 mb-1.5">{title}:</h5>
      <div className="text-[0.9rem] text-gray-700">
        <RenderMarkdownWithLatex text={String(value)} />
      </div>
    </div>
  );
};

const LinkedFormulaItem = ({ item, onDelete, problemId }) => {
    if (!item || !item.matura_formula_match_id) return null;
    return (
      <div className="p-2 border border-gray-200 rounded mb-2 bg-gray-50/50">
        <div className="flex justify-between items-start">
          <div className="w-full">
            {item.name && (
              <p className="text-sm font-medium text-gray-700">
                <RenderMarkdownWithLatex text={item.name} />
              </p>
            )}
            {item.text && (
              <div className="text-xs text-gray-600 mt-1 pl-2 border-l-2 border-gray-300">
                <RenderMarkdownWithLatex text={item.text} />
              </div>
            )}
            {/* NOWY PRZYCISK "SUROWA TREŚĆ" DLA WZORÓW */}
            <div className="mt-2">
                <button
                  onClick={() => window.alert(`Nazwa wzoru:\n${item.name}\n\nTreść:\n${item.text}`)}
                  className="text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-0.5 rounded"
                >
                  Surowa treść
                </button>
            </div>
          </div>
          {onDelete && (
            <button
              onClick={() => onDelete(item.matura_formula_match_id, 'formula_match', problemId)}
              title={`Usuń powiązanie wzoru (ID powiązania: ${item.matura_formula_match_id})`}
              className="ml-2 text-lg text-red-500 hover:text-red-700 transition-colors flex-shrink-0"
              aria-label="Usuń powiązanie wzoru"
            >
              &times;
            </button>
          )}
        </div>
      </div>
    );
};

const LinkedMaturaProblemItem = ({ item, onDelete, problemId }) => {
  if (!item || !item.matura_problem_match_id) return null;
  return (
    <div className="p-2 border border-gray-200 rounded mb-2 bg-gray-50/50">
      <div className="flex justify-between items-start">
        <div className="w-full">
          {item.question_snippet && (
            <div className="text-sm font-medium text-gray-700">
              <RenderMarkdownWithLatex text={item.question_snippet} />
            </div>
          )}
          <div className="flex items-center mt-2">
            {item.source && (
              <p className="text-xs text-gray-500">
                (Źródło: {item.source})
              </p>
            )}
            {/* NOWY PRZYCISK "SUROWA TREŚĆ" */}
            <button
              onClick={() => window.alert(item.question_snippet)}
              className="text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-0.5 rounded ml-4"
            >
              Surowa treść
            </button>
          </div>
        </div>
        {onDelete && (
          <button
            onClick={() => onDelete(item.matura_problem_match_id, 'problem_match', problemId)}
            title={`Usuń powiązanie zadania (ID powiązania: ${item.matura_problem_match_id})`}
            className="ml-2 text-lg text-red-500 hover:text-red-700 transition-colors flex-shrink-0"
            aria-label="Usuń powiązanie zadania"
          >
            &times;
          </button>
        )}
      </div>
    </div>
  );
};

const ProblemDisplayForTest = ({
  problem,
  index,
  totalProblems,
  onReportIssue,
  onCorrectIssueRequest,
  onAskAI,
  onDeleteLinkedItem,
  onManageProblem,
}) => {
  const [imageLoadError, setImageLoadError] = useState(false);
  
  // ZMIANA: Domyślnie TRUE, żeby wszystko było od razu widoczne
  const [showHint, setShowHint] = useState(true);
  const [showSolution, setShowSolution] = useState(true);

  const imageUrl = problem.image_link
    ? (problem.image_link.startsWith('http') ? problem.image_link : `${process.env.REACT_APP_STATIC_FILES_SOURCE || ''}/images/${problem.image_link}`)
    : null;

  const answers = [
    { text: problem.true_answer, isCorrect: true },
    { text: problem.false_answer1, isCorrect: false },
    { text: problem.false_answer2, isCorrect: false },
    { text: problem.false_answer3, isCorrect: false },
  ].filter(ans => ans && ans.text);

  const currentProblemId = problem.problem_translation_id || problem.problem_id;

  return (
    <div className="problem-container border border-gray-300 rounded-lg p-4 sm:p-6 mb-6 shadow-sm bg-white relative">
      <div className="mb-3 pb-2 border-b border-gray-200">
        <h3 className="text-md sm:text-lg font-semibold text-gray-700">
          Zadanie {index + 1} z {totalProblems}
        </h3>
        <div className="flex items-center gap-x-4 text-xs text-gray-400 mt-0.5">
            <p>ID: {problem.problem_id} (PT_ID: {currentProblemId || 'brak'})</p>
            <p className="font-bold text-gray-600">ELO: {problem.problem_elo}</p>
        </div>
        <p className={`text-xs font-medium mt-1 ${problem.is_mobile ? 'text-green-600' : 'text-orange-600'}`}>
          Zadanie bez obliczeń: {problem.is_mobile ? 'Tak' : 'Nie'}
        </p>
      </div>

      <div className="mb-4 text-gray-900 text-[1.0rem] sm:text-[1.06rem] leading-relaxed">
        <RenderMarkdownWithLatex text={problem.question || "Brak treści pytania."} />
      </div>

      {problem.linked_template && (
        <div className="my-4 p-3 border border-purple-200 bg-purple-50 rounded-lg">
            <h5 className="text-[0.92rem] font-semibold text-purple-800 mb-1.5">Podpięty szablon (ID: {problem.linked_template.problem_id}):</h5>
            <div className="text-sm text-gray-700 italic border-l-4 border-purple-300 pl-3">
                <RenderMarkdownWithLatex text={problem.linked_template.question} />
            </div>
        </div>
      )}

      <div className="matura-features-container my-4 py-3 border-y border-gray-200 space-y-4">
        <MaturaDataArraySection title="Treść zadania (ze źródła maturalnego)" items={problem.matura_problem_question_raw || problem.matura_problem_question} />
        <MaturaDataArraySection title="Zastosowane wzory (nazwy)" items={problem.matura_formula_name_raw || problem.matura_formula_name} />
        <MaturaDataArraySection title="Zastosowane wzory (treść)" items={problem.matura_formula_text_raw || problem.matura_formula_text} />
        <MaturaDataArraySection title="Źródło zadania" items={problem.matura_problem_source_raw || problem.matura_problem_source} />

        {problem.linked_matura_problems && problem.linked_matura_problems.length > 0 && (
          <div className="mt-3 pt-3 border-t border-gray-200">
            <h5 className="text-[0.92rem] font-semibold text-gray-500 mb-1.5">Podpięte zadania maturalne (powiązania):</h5>
            <div className="space-y-1">
              {problem.linked_matura_problems.map(item => (
                <LinkedMaturaProblemItem 
                  key={item.matura_problem_match_id}
                  item={item}
                  onDelete={onDeleteLinkedItem}
                  problemId={currentProblemId}
                />
              ))}
            </div>
          </div>
        )}

        {problem.linked_formulas && problem.linked_formulas.length > 0 && (
          <div className="mt-3 pt-3 border-t border-gray-200">
            <h5 className="text-[0.92rem] font-semibold text-gray-500 mb-1.5">Podpięte wzory z kart (powiązania):</h5>
            <div className="space-y-1">
              {problem.linked_formulas.map(item => (
                <LinkedFormulaItem
                  key={item.matura_formula_match_id}
                  item={item}
                  onDelete={onDeleteLinkedItem}
                  problemId={currentProblemId}
                />
              ))}
            </div>
          </div>
        )}
        
        <MaturaDataSingleValueSection
            title="Liczba punktów za zadanie"
            value={problem.points_assigned !== null && problem.points_assigned !== undefined ? Number(problem.points_assigned).toLocaleString('pl-PL') : null}
        />
      </div>

      {imageUrl && !imageLoadError && ( <div className="flex justify-center my-4"> <img src={imageUrl} alt={`Ilustracja do zadania ${problem.problem_id}`} className="max-w-full h-auto rounded border border-gray-300" onError={() => {setImageLoadError(true);}} /> </div> )}
      {imageLoadError && (<p className="text-red-600 text-sm my-2 text-center">Błąd ładowania obrazka.</p>)}

      {answers.length > 0 && ( <div className="mt-5"> <h4 className="font-semibold text-sm text-gray-600 mb-2">Odpowiedzi:</h4> <div className="space-y-2"> {answers.map((answer, i) => ( <div key={i} className={`p-3 border rounded text-sm ${answer.isCorrect ? "bg-green-50 border-green-300 text-green-800 font-medium" : "bg-gray-50 border-gray-200 text-gray-800"}`}> <RenderMarkdownWithLatex text={answer.text} /> </div> ))} </div> </div> )}
      
      {/* --- SEKCJA PODPOWIEDZI (DOMYŚLNIE OTWARTA) --- */}
      {(problem.hint || (problem.linked_formulas && problem.linked_formulas.length > 0)) && (
         <div className="mt-6 border-t pt-4">
            <button 
                onClick={() => setShowHint(!showHint)}
                className="text-xs uppercase font-bold text-gray-500 hover:text-gray-800 mb-2 flex items-center gap-2"
            >
                {showHint ? "▼ Ukryj Podpowiedź i Wzory" : "▶ Pokaż Podpowiedź i Wzory (Podgląd)"}
            </button>
            
            {showHint && (
                <div className="border border-dashed border-gray-300 p-2 rounded bg-gray-50/30">
                    <HintAndFormulas 
                        hintText={problem.hint}
                        formulas={problem.linked_formulas}
                    />
                </div>
            )}
         </div>
      )}

      {/* --- SEKCJA ROZWIĄZANIA (DOMYŚLNIE OTWARTA) --- */}
      {problem.solution && (
         <div className="mt-4">
            <button 
                onClick={() => setShowSolution(!showSolution)}
                className="text-xs uppercase font-bold text-blue-600 hover:text-blue-800 mb-2 flex items-center gap-2"
            >
                {showSolution ? "▼ Ukryj Rozwiązanie (Stepper)" : "▶ Pokaż Rozwiązanie (Stepper - Podgląd)"}
            </button>
            
            {showSolution && (
                <div className="border border-dashed border-blue-200 p-2 rounded bg-blue-50/10">
                    <SolutionStepper solutionText={problem.solution} />
                </div>
            )}
         </div>
      )}

      <div className="absolute top-3 right-3 flex flex-col space-y-1 sm:flex-row sm:space-y-0 sm:space-x-1 sm:items-center">
        <button onClick={() => onManageProblem(problem)} title="Zarządzaj zadaniem" className="text-xs bg-blue-100 text-blue-700 hover:bg-blue-200 px-2 py-1 rounded border border-blue-300 shadow-sm whitespace-nowrap">Zarządzaj Zad.</button>
        {onAskAI && (<button onClick={() => onAskAI(problem)} title="Zapytaj AI" className="text-xs bg-indigo-100 text-indigo-700 hover:bg-indigo-200 px-2 py-1 rounded border border-indigo-300 shadow-sm whitespace-nowrap">Zapytaj AI</button>)}
        {onCorrectIssueRequest && (<button onClick={() => onCorrectIssueRequest(problem)} title="Popraw zadanie" className="text-xs bg-yellow-100 text-yellow-700 hover:bg-yellow-200 px-2 py-1 rounded border border-yellow-300 shadow-sm whitespace-nowrap">Popraw Zad.</button>)}
        <button onClick={() => onReportIssue(problem.problem_id, problem.field_id)} title="Zgłoś błąd" className="text-xs bg-red-100 text-red-700 hover:bg-red-200 px-2 py-1 rounded border border-red-300 shadow-sm whitespace-nowrap">Zgłoś Błąd</button>
      </div>
    </div>
  );
};

const ProblemRenderMaturaScreen = () => {
  const [fields, setFields] = useState([]);
  const [selectedField, setSelectedField] = useState("");
  const [subfields, setSubfields] = useState([]);
  const [selectedSubfield, setSelectedSubfield] = useState("");
  const [problems, setProblems] = useState([]);
  const [loadingConfig, setLoadingConfig] = useState(false);
  const [loadingProblems, setLoadingProblems] = useState(false);
  const [error, setError] = useState(null);
  const [mobileFilter, setMobileFilter] = useState('all');

  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [reportingProblemData, setReportingProblemData] = useState(null);

  const [isCorrectionModalOpen, setIsCorrectionModalOpen] = useState(false);
  const [currentProblemForCorrection, setCurrentProblemForCorrection] = useState(null);
  const [aiCorrectedData, setAiCorrectedData] = useState(null);
  const [isRequestingCorrection, setIsRequestingCorrection] = useState(false);
  const [isAcceptingCorrection, setIsAcceptingCorrection] = useState(false);
  const [correctionError, setCorrectionError] = useState(null);

  const [isGeneralAiChatOpen, setIsGeneralAiChatOpen] = useState(false);
  const [currentProblemForGeneralAiChat, setCurrentProblemForGeneralAiChat] = useState(null);
  const [generalAiChatHistory, setGeneralAiChatHistory] = useState([]);
  const [isGeneralAiResponding, setIsGeneralAiResponding] = useState(false);
  const [problemSpecificChatHistories, setProblemSpecificChatHistories] = useState({});

  const [isSubfieldModalOpen, setIsSubfieldModalOpen] = useState(false);
  const [managingProblem, setManagingProblem] = useState(null); // Będzie przechowywać obiekt całego problemu

  const fetchFieldsConfig = async () => {
    setLoadingConfig(true);
    setError(null);
    try {
      const response = await fetch(`${apiUrl}problems_config_test/?lang=pl`, {
        headers: { "Content-Type": "application/json", Authorization: `Token ${token}` }
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      setFields(data);
    } catch (e) {
      console.error("Nie udało się pobrać konfiguracji pól:", e);
      setError("Nie udało się pobrać konfiguracji pól.");
    } finally { setLoadingConfig(false); }
  };

  useEffect(() => {
    if (token) {
        fetchFieldsConfig();
    } else {
        setError("Brak tokena autoryzacyjnego. Zaloguj się.");
        setLoadingConfig(false);
    }
  }, [token]);

  useEffect(() => {
    if (selectedField) {
      const fieldData = fields.find((f) => f.field_id === parseInt(selectedField));
      setSubfields(fieldData ? fieldData.subfields : []);
      setSelectedSubfield("");
      setProblems([]);
    } else {
      setSubfields([]);
      setSelectedSubfield("");
      setProblems([]);
    }
  }, [selectedField, fields]);

    const handleFetchProblems = async () => {
    if (!selectedField) {
      alert("Proszę wybrać dział.");
      return;
    }
    if (!token) {
      alert("Brak tokena autoryzacyjnego. Zaloguj się.");
      return;
    }

    setLoadingProblems(true);
    setProblems([]);
    setError(null);

    let fetchUrl = `${apiUrl}problems_list_matura/?lang=pl`;
    if (selectedSubfield) {
        fetchUrl += `&subfield_id=${selectedSubfield}`;
    } else {
        fetchUrl += `&field_id=${selectedField}`;
    }

    try {
      const response = await fetch(fetchUrl, {
        headers: { "Content-Type": "application/json", Authorization: `Token ${token}` }
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      setProblems(data.map(p => ({ 
        ...p, 
        problem_translation_id: p.problem_translation_id || p.problem_id,
        linked_formulas: p.linked_formulas || [], 
        linked_matura_problems: p.linked_matura_problems || [],
        matura_formula_name_raw: p.matura_formula_name || [],
        matura_formula_text_raw: p.matura_formula_text || [],
        matura_problem_question_raw: p.matura_problem_question || [],
        matura_problem_source_raw: p.matura_problem_source || [],
      })));

      if (data.length === 0) {
        setError(selectedSubfield 
            ? "Nie znaleziono zadań dla wybranego poddziału."
            : "Nie znaleziono zadań dla wybranego działu."
        );
      }
    } catch (e) {
      console.error("Nie udało się pobrać zadań:", e);
      setError("Nie udało się pobrać zadań.");
    } finally {
      setLoadingProblems(false);
    }
  };

  const handleReportIssue = (problemId, fieldId) => {
    setReportingProblemData({ problem_id: problemId, field_id: fieldId });
    setIsReportModalOpen(true);
  };
  
  const handleCloseReportModal = () => {
    setIsReportModalOpen(false);
    setReportingProblemData(null);
  };

  const handleCorrectIssueRequest = async (problem) => {
    const userInstructions = window.prompt(
      "Wprowadź dodatkowe instrukcje dla AI (np. 'zmień liczby na całkowite', 'uprość treść') lub zostaw puste, aby użyć domyślnych reguł.",
      ""
    );

    if (userInstructions === null) {
      return; 
    }

    const problemIdForCorrection = problem.problem_translation_id || problem.problem_id;
    if (!problemIdForCorrection) {
      alert("Brak ID zadania do korekty.");
      return;
    }
    
    setCurrentProblemForCorrection(problem);
    setIsRequestingCorrection(true);
    setCorrectionError(null);
    setAiCorrectedData(null);
    
    try {
      const problemDataPayload = {
        problem_translation_id: problemIdForCorrection,
        question: problem.question,
        true_answer: problem.true_answer,
        false_answer1: problem.false_answer1,
        false_answer2: problem.false_answer2,
        false_answer3: problem.false_answer3,
        hint: problem.hint,
        solution: problem.solution,
        context_level: "matura",
        user_instructions: userInstructions,
      };

      const response = await fetch(`${apiUrl}correct_problem_content/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${token}` },
        body: JSON.stringify(problemDataPayload),
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.detail || `Błąd serwera: ${response.status}`);
      }

      const data = await response.json();
      setAiCorrectedData(data);
      setIsCorrectionModalOpen(true);
    } catch (e) {
      console.error("Błąd korekty AI:", e);
      setCorrectionError(`Nie udało się uzyskać korekty: ${e.message}`);
    } finally {
      setIsRequestingCorrection(false);
    }
  };

  const handleAcceptCorrection = async () => {
    if (!aiCorrectedData || !currentProblemForCorrection) { setCorrectionError("Brak danych do akceptacji."); return; }
    const problemIdToUpdate = currentProblemForCorrection.problem_translation_id || currentProblemForCorrection.problem_id;
    if (!problemIdToUpdate) { setCorrectionError("Brak ID do aktualizacji."); return; }
    setIsAcceptingCorrection(true); setCorrectionError(null);
    try {
      const response = await fetch(`${apiUrl}problem_translation/${problemIdToUpdate}/update_corrected/`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json', Authorization: `Token ${token}` },
        body: JSON.stringify(aiCorrectedData),
      });
      if (!response.ok) { const errData = await response.json().catch(() => ({})); throw new Error(errData.detail || `Błąd serwera: ${response.status}`); }
      setProblems(prevProblems => prevProblems.map(p => {
          const currentPId = p.problem_translation_id || p.problem_id;
          if (currentPId === problemIdToUpdate) {
            return { ...p, question: aiCorrectedData.corrected_question, true_answer: aiCorrectedData.corrected_true_answer, false_answer1: aiCorrectedData.corrected_false_answer1, false_answer2: aiCorrectedData.corrected_false_answer2, false_answer3: aiCorrectedData.corrected_false_answer3, hint: aiCorrectedData.corrected_hint, solution: aiCorrectedData.corrected_solution };
          } return p;
        })
      );
      setIsCorrectionModalOpen(false); setAiCorrectedData(null); setCurrentProblemForCorrection(null);
      alert("Zadanie zaktualizowane!");
    } catch (e) { console.error("Błąd akceptacji korekty:", e); setCorrectionError(`Nie udało się zaktualizować: ${e.message}`);
    } finally { setIsAcceptingCorrection(false); }
  };
  
  const handleCloseCorrectionModal = () => {
    setIsCorrectionModalOpen(false); setAiCorrectedData(null); setCurrentProblemForCorrection(null); setCorrectionError(null);
  };

  const handleAskGeneralAI = async (problem) => {
    setCurrentProblemForGeneralAiChat(problem); setIsGeneralAiChatOpen(true);
    const problemIdForChat = problem.problem_translation_id || problem.problem_id;
    const existingHistory = problemSpecificChatHistories[problemIdForChat] || [];
    setGeneralAiChatHistory(existingHistory);
    if (existingHistory.length > 0 || isGeneralAiResponding) return;
    setIsGeneralAiResponding(true);
    try {
      let initialUserMessageForAI = `Pytanie o zadanie maturalne (ID: ${problem.problem_id}):\nTreść: "${problem.question}".`;
      if (problem.true_answer) initialUserMessageForAI += `\nPoprawna odp: "${problem.true_answer}".`;
      if (problem.solution) initialUserMessageForAI += `\nRozwiązanie: "${problem.solution}".`;
      initialUserMessageForAI += `\n\nProszę o pomoc w zrozumieniu.`;
      const { updatedHistory } = await startChatAndGenerateSolution(initialUserMessageForAI, null, problem.true_answer, problem.points_assigned, process.env.REACT_APP_GEMINI_API_KEY);
      setGeneralAiChatHistory(updatedHistory);
      setProblemSpecificChatHistories(prev => ({ ...prev, [problemIdForChat]: updatedHistory }));
    } catch (err) { console.error("Błąd czatu AI:", err); setGeneralAiChatHistory([{ role: 'model', parts: [{ text: "Błąd łączenia z AI." }] }]);
    } finally { setIsGeneralAiResponding(false); }
  };

  const handleSendGeneralChatMessage = async (message) => {
    if (!currentProblemForGeneralAiChat) return;
    const problemIdForChat = currentProblemForGeneralAiChat.problem_translation_id || currentProblemForGeneralAiChat.problem_id;
    const currentStoredHistory = problemSpecificChatHistories[problemIdForChat] || [];
    const provisionalUserMsg = { role: "user", parts: [{ text: message }] };
    setGeneralAiChatHistory([...currentStoredHistory, provisionalUserMsg]);
    setIsGeneralAiResponding(true);
    try {
      const { updatedHistory } = await continueChat(currentStoredHistory, message, currentProblemForGeneralAiChat.points_assigned, process.env.REACT_APP_GEMINI_API_KEY);
      setGeneralAiChatHistory(updatedHistory);
      setProblemSpecificChatHistories(prev => ({ ...prev, [problemIdForChat]: updatedHistory }));
    } catch (err) { console.error("Błąd wysyłania wiadomości AI:", err); setGeneralAiChatHistory(prev => [...prev, { role: 'model', parts: [{ text: "Błąd odpowiedzi AI." }] }]);
    } finally { setIsGeneralAiResponding(false); }
  };
  
  const handleCloseGeneralAiChat = () => setIsGeneralAiChatOpen(false);
  const handleProblemDataChange = () => {
    // Najprostsza metoda to ponowne wywołanie funkcji pobierającej problemy,
    // aby odświeżyć listę i zobaczyć np. zaktualizowane ELO.
    handleFetchProblems();
  };
  const handleDeleteLinkedItem = async (matchIdToDelete, itemType, problemIdToUpdateLocally) => {
    const itemTypeName = itemType === 'formula_match' ? 'podpięty wzór (powiązanie)' : 'podpięte zadanie maturalne (powiązanie)';
    if (!window.confirm(`Czy na pewno chcesz usunąć ${itemTypeName} o ID ${matchIdToDelete}?`)) return;

    let deleteUrl = '';
    if (itemType === 'formula_match') deleteUrl = `${apiUrl}matura_formula_match/${matchIdToDelete}/delete/`;
    else if (itemType === 'problem_match') deleteUrl = `${apiUrl}matura_problem_match/${matchIdToDelete}/delete/`;
    else { alert("Błąd: nieznany typ elementu."); return; }

    try {
      const response = await fetch(deleteUrl, {
        method: 'DELETE', headers: { 'Content-Type': 'application/json', Authorization: `Token ${token}` },
      });
      if (!response.ok) { const errData = await response.json().catch(() => ({})); throw new Error(errData.detail || `Nie udało się usunąć (status: ${response.status})`); }
      
      setProblems(prevProblems => prevProblems.map(p => {
          const currentPId = p.problem_translation_id || p.problem_id;
          if (currentPId === problemIdToUpdateLocally) {
            const updatedProblem = { ...p };
            if (itemType === 'formula_match') {
              updatedProblem.linked_formulas = (updatedProblem.linked_formulas || []).filter(
                f => f.matura_formula_match_id !== matchIdToDelete
              );
            } else if (itemType === 'problem_match') {
              updatedProblem.linked_matura_problems = (updatedProblem.linked_matura_problems || []).filter(
                pm => pm.matura_problem_match_id !== matchIdToDelete
              );
            }
            return updatedProblem;
          }
          return p;
        })
      );
      alert(`${itemTypeName} (ID: ${matchIdToDelete}) został pomyślnie usunięty.`);
    } catch (e) { console.error(`Błąd usuwania ${itemTypeName}:`, e); alert(`Nie udało się usunąć: ${e.message}`); }
  };

  const filteredProblems = problems.filter(problem => {
    if (mobileFilter === 'mobile') return problem.is_mobile === true;
    if (mobileFilter === 'non-mobile') return problem.is_mobile === false;
    return true;
  });

  return (
    <div className="container mx-auto px-4 py-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6 text-gray-800 border-b pb-2">
        Test Renderowania Zadań Maturalnych
      </h1>
      {isRequestingCorrection && <p className="fixed top-5 left-1/2 -translate-x-1/2 bg-blue-500 text-white px-4 py-2 rounded shadow-lg z-[100]">AI Poprawia Zadanie...</p>}
      {isGeneralAiResponding && !isGeneralAiChatOpen && <p className="fixed top-5 left-1/2 -translate-x-1/2 bg-indigo-500 text-white px-4 py-2 rounded shadow-lg z-[100]">AI Myśli (Czat)...</p>}

      <div className="bg-white p-4 rounded-lg shadow mb-6">
        <h2 className="text-lg font-semibold mb-3 text-gray-700">Wybierz zakres zadań</h2>
        {loadingConfig && <p className="text-blue-600">Ładowanie konfiguracji...</p>}
        {error && !loadingConfig && <p className="text-red-600 mb-2">{error}</p>}
        <div className="flex flex-wrap items-center gap-4">
          <select value={selectedField} onChange={(e) => setSelectedField(e.target.value)} className="border border-gray-300 rounded p-2 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={loadingConfig || !token}>
            <option value="">--- Wybierz Dział ---</option>
            {fields.map((field) => (<option key={field.field_id} value={field.field_id}>{field.field_name} ({field.knowledge_level})</option>))}
          </select>
          <select value={selectedSubfield} onChange={(e) => setSelectedSubfield(e.target.value)} className="border border-gray-300 rounded p-2 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={!selectedField || subfields.length === 0 || !token}>
            <option value="">--- Cały Dział / Wybierz Poddział ---</option>
            {subfields.map((subfield) => (<option key={subfield.subfield_id} value={subfield.subfield_id}>{subfield.subfield_name}</option>))}
          </select>

          <button
            type="button"
            onClick={() => setIsSubfieldModalOpen(true)}
            className="bg-gray-600 text-white px-3 py-2 rounded font-semibold text-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={!selectedField || loadingConfig}
            title="Zarządzaj poddziałami dla wybranego działu"
          >
            ⚙️ Zarządzaj
          </button>
          
          <select value={mobileFilter} onChange={(e) => setMobileFilter(e.target.value)} className="border border-gray-300 rounded p-2 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={loadingProblems || loadingConfig || !token}>
            <option value="all">Wszystkie (Mobile/Non-Mobile)</option>
            <option value="mobile">Tylko Mobilne</option>
            <option value="non-mobile">Tylko Nie-Mobilne</option>
          </select>
          <button
            onClick={handleFetchProblems}
            className="bg-blue-600 text-white px-4 py-2 rounded font-semibold hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50"
            disabled={!selectedField || loadingProblems || loadingConfig || !token || isRequestingCorrection || (isGeneralAiResponding && !isGeneralAiChatOpen)}
          >
            {loadingProblems ? "Ładowanie zadań..." : "Pobierz Zadania"}
          </button>
        </div>
      </div>
       {/* vvv NOWA SEKCJA vvv */}
      {selectedSubfield && (
        <SubfieldSummary subfieldId={selectedSubfield} />
      )}
      {/* ^^^ KONIEC NOWEJ SEKCJI ^^^ */}

      <div className="mt-6">
        {loadingProblems && <p className="text-blue-600 text-center py-4">Ładowanie zadań...</p>}
        {error && !loadingProblems && problems.length === 0 && <p className="text-red-600 mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">{error}</p>}
        {!loadingProblems && problems.length > 0 && (
          <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg text-blue-800">
            Liczba wyświetlonych zadań: <span className="font-bold">{filteredProblems.length}</span>
            {problems.length !== filteredProblems.length && (<span className="text-sm text-gray-600"> (z {problems.length} załadowanych)</span>)}
          </div>
        )}
        {!loadingProblems && filteredProblems.map((problem, index) => (
          <ProblemDisplayForTest
            key={problem.problem_translation_id || problem.problem_id}
            problem={problem}
            index={index}
            totalProblems={filteredProblems.length}
            onReportIssue={handleReportIssue}
            onCorrectIssueRequest={handleCorrectIssueRequest}
            onAskAI={handleAskGeneralAI}
            onDeleteLinkedItem={handleDeleteLinkedItem}
            onManageProblem={setManagingProblem}
          />
        ))}
        {!loadingConfig && !loadingProblems && problems.length > 0 && filteredProblems.length === 0 && !error && (
          <p className="text-gray-500 mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">Brak zadań spełniających kryteria filtrowania.</p>
        )}
        {!loadingConfig && !loadingProblems && problems.length === 0 && selectedSubfield && !error && (
          <p className="text-gray-500 p-3 bg-gray-50 border border-gray-200 rounded-lg">Brak zadań dla wybranego poddziału.</p>
        )}
      </div>

      {isReportModalOpen && reportingProblemData && (
        <ReportIssueModal onClose={handleCloseReportModal} reportIssueData={reportingProblemData} />
      )}
      {isCorrectionModalOpen && currentProblemForCorrection && aiCorrectedData && (
        <CorrectionModal
          isOpen={isCorrectionModalOpen}
          onClose={handleCloseCorrectionModal}
          originalProblem={currentProblemForCorrection}
          correctedData={aiCorrectedData}
          onAcceptCorrection={handleAcceptCorrection}
          isAccepting={isAcceptingCorrection}
          error={correctionError}
        />
      )}
      {isGeneralAiChatOpen && currentProblemForGeneralAiChat && (
        <AiChatPopup
          isOpen={isGeneralAiChatOpen}
          onClose={handleCloseGeneralAiChat}
          chatTitle={`Pytanie o zadanie ID: ${currentProblemForGeneralAiChat.problem_id}`}
          chatHistory={generalAiChatHistory}
          onSendMessage={handleSendGeneralChatMessage}
          isResponding={isGeneralAiResponding}
          problemQuestion={currentProblemForGeneralAiChat.question}
        />
      )}
      
      {isSubfieldModalOpen && (
        <SubfieldManagerModal
          isOpen={isSubfieldModalOpen}
          onClose={() => setIsSubfieldModalOpen(false)}
          fieldId={selectedField}
          onDataChange={fetchFieldsConfig}
        />
      )}
      {managingProblem && (
        <ProblemManagerModal 
          problem={managingProblem}
          onClose={() => setManagingProblem(null)}
          onDataChange={handleProblemDataChange}
        />
      )}
    </div>
  );
};

export default ProblemRenderMaturaScreen;